import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import moment from 'moment-timezone'

import {INSTRUCTIONS_SEARCH_QUERY_KEY, INSTRUCTIONS_TENANT_ID} from '../../consts'
import {prepareInstructionFormData} from '../../mappers'
import {DocumentUpdate, Instruction} from '../../types/documents.types'

type Params = {
  plantId: string
  timezone: string
  options?: UseMutationOptions<Instruction, AxiosError, DocumentUpdate>
}

export const useInstructionEdit = ({plantId, timezone, options}: Params) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (document: DocumentUpdate) => {
      const formData = prepareInstructionFormData(document)
      const response = await ApiClient.axiosInstance.put<DocumentUpdate>(
        `/instructions/${INSTRUCTIONS_TENANT_ID}/plants/${plantId}/instructions/${document.id}`,
        formData
      )
      return {
        ...response.data,
        validFrom: moment.utc(response.data.validFrom).tz(timezone),
        validTo: moment.utc(response.data.validTo).tz(timezone),
        createdAt: moment.utc(response.data.createdAt).tz(timezone),
        updatedAt: moment.utc(response.data.updatedAt).tz(timezone)
      }
    },
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({queryKey: [INSTRUCTIONS_SEARCH_QUERY_KEY]})
      await options?.onSuccess?.(...args)
    }
  })
}
